import { useMemo } from 'react';
import { useAppScopeStore } from '@frontend/scope';
import { useIsIntegratedOffice } from '../../../hooks';

export const useHasAppointmentAnalyticsFeature = () => {
  const { isIntegratedOffice } = useIsIntegratedOffice();
  const { isSingleTypeScope, scopeHierarchy, selectedOrgId } = useAppScopeStore();

  const isMultiLocation = useMemo(() => {
    // In the past we have seen instances when the isSingleTypeScope always didn't help to identify the location type
    // The OR condition is a fallback solution for the same that had helped us in the past
    return !isSingleTypeScope || Object.values(scopeHierarchy?.[selectedOrgId] ?? {}).flat().length > 1;
  }, [isSingleTypeScope, scopeHierarchy, selectedOrgId]);

  if (isMultiLocation) {
    // Appointment analytics is not supported for:
    // 1. multi-locations and
    // 2. multiple single locations within the same org
    return false;
  }

  return !!isIntegratedOffice;
};
